(window.YPStateSelector = function ($, Behaviors) {
    "use strict";

    const module = {};


    function YPStateSelector(elem) {
        const stateSections = $('.YPStateSelector');

        if (!stateSections.length) {
            return;
        }

        const getStateAjax = (state_code, section) => {
            let json = section.attr('yp-states-json');
            if (!json) {
                console.log('empty json field')
                return false;
            }

            json = JSON.parse(json);

            const stateData = json[state_code];

            section.find('.YPStateTitle').text(stateData.title);
            section.find('.YPStateDescription').html(stateData.description);
            section.find('.YPStateLink').attr('href', stateData.link);

        };

        stateSections.each(function (index, section) {
            section = $(section);
            let map = section.find('.ypUSMap');
            const select = section.find('.YPStateSelect');

            map = map.usmap({
                stateStyles: {
                    fill: '#d1d6ea',
                    "stroke-width": 1,
                    'stroke': '#fff'
                },

                stateHoverStyles: {
                    fill: '#748bd7'
                },

                showLabels: false,

                'click': function (event, data) {
                    select.val(data.name);
                    map.find(' > svg > path').each(function () {
                        $(this).css('fill', '');
                    });

                    map.find('#' + data.name).css('fill', '#748bd7');

                    getStateAjax(data.name, section);

                }
            });


            select.on('change', function (e) {
                map.usmap('trigger', this.value, 'click');
            });
        });
    }

    module.YPStateSelector = YPStateSelector;

    $(document).ready(module.YPStateSelector);

    return module;

}(window.jQuery, window.Behaviors));